import { render, staticRenderFns } from "./moreKnowedge.vue?vue&type=template&id=4f5cab66&scoped=true&"
import script from "./moreKnowedge.vue?vue&type=script&lang=js&"
export * from "./moreKnowedge.vue?vue&type=script&lang=js&"
import style0 from "./moreKnowedge.vue?vue&type=style&index=0&id=4f5cab66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cab66",
  null
  
)

export default component.exports